<template>
  <div class="p-grid dashboard">
    <div class="p-col-12">
      <Toast />

      <div class="card">
        <div class="title">Laporan Refund</div>
        <DataTable
          :value="refund"
          :paginator="true"
          class="p-datatable-outlets"
          :rows="20"
          data-key="doc_number"
          :rowHover="true"
          :scrollable="true"
          scrollDirection="horizontal"
        >
          <template #header>
            <div class="p-grid p-fluid p-mb-2">
              <div class="p-col">
                <label style="font-size: 14px">Tanggal Refund</label>
                <Calendar
                  v-model="trx_date"
                  :showIcon="true"
                  dateFormat="yy-mm-dd"
                  placeholder="Audit Date"
                  :selectOtherMonths="true"
                  :showButtonBar="true"
                />
              </div>
              <div class="p-col">
                <label style="font-size: 14px">kode barang Refund</label>
                <InputText v-model="barcode" placeholder="kode Barang" />
              </div>
              <div class="p-col">
                <!-- <label style="font-size: 14px; z-index: -999">-</label> -->
                <Button
                  label="Cari"
                  class="p-button-info"
                  style="margin-top: 2.2rem"
                  @click="getReportRefund()"
                  v-shortkey.push="['enter']"
                  @shortkey="getReportRefund()"
                />
              </div>
              <div
                class="p-col"
                v-if="refund.length > 0"
                style="margin-top: 2.2rem"
              >
                <router-link
                  :to="{
                    name: 'print-report-refund',
                    query: {
                      trx_date: moment(trx_date).format('YYYY-MM-DD'),
                      outlet_id: user
                    }
                  }"
                  target="_blank"
                >
                  <Button
                    label="Print"
                    icon="pi pi-print"
                    class="p-button-success"
                  />
                </router-link>
              </div>
            </div>
            <!-- <table
              class="table table-responsive"
              style="font-size: 16px"
              v-if="refund.length > 0"
            >
              <thead class="thead-light">
                <tr>
                  <th>Metode Pembayaran</th>
                  <th>Jumlah</th>
                  <th>Total Omset</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(an_item, k) in payment_method" :key="k">
                  <td>
                    <h5>{{ an_item.name_payment }}</h5>
                  </td>
                  <td>{{ an_item.total_payment | currency }}</td>
                  <td v-if="k == 0">{{ total_omset | currency }}</td>
                </tr>
              </tbody>
            </table> -->
          </template>
          <template #empty>Data tidak ditemukan.</template>
          <template #loading
            >Mengambil data daftar retur. Mohon tunggu</template
          >
          <Column
            header="Tanggal"
            headerStyle="text-align: center; width: 10rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.trx_date }}
              </div>
            </template>
          </Column>
          <Column
            header="Kode Voucher"
            headerStyle="text-align: center; width: 10rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.voucher_code }}
              </div>
            </template>
          </Column>
          <Column
            header="Invoice Refund"
            headerStyle="text-align: center; width: 10rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.invoice_refund }}
              </div>
            </template>
          </Column>
          <Column
            header="Kode Barang"
            headerStyle="text-align: center; width: 10rem"
          >
            <template #body="slotProps">
              <div
                style="text-align: center"
                v-for="(an_item, k) in slotProps.data.items_refund"
                :key="k"
              >
                {{ an_item.code_refund }}
              </div>
            </template>
          </Column>
          <Column
            header="Nama Barang"
            headerStyle="text-align: center; width: 12rem"
          >
            <template #body="slotProps">
              <div
                style="text-align: center"
                v-for="(an_item, k) in slotProps.data.items_refund"
                :key="k"
              >
                {{ an_item.name_refund }}
              </div>
            </template>
          </Column>
          <Column
            header="Qty Refund"
            headerStyle="text-align: center; width: 10rem"
          >
            <template #body="slotProps">
              <div
                style="text-align: center"
                v-for="(an_item, k) in slotProps.data.items_refund"
                :key="k"
              >
                {{ an_item.qty_refund | number }}
              </div>
            </template>
          </Column>
          <Column header="Harga" headerStyle="text-align: center; width: 10rem">
            <template #body="slotProps">
              <div
                style="text-align: center"
                v-for="(an_item, k) in slotProps.data.items_refund"
                :key="k"
              >
                {{ an_item.price_refund | currency }}
              </div>
            </template>
          </Column>
          <Column
            header="Total Refund"
            headerStyle="text-align: center; width: 10rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.total_price_refund | currency }}
              </div>
            </template>
          </Column>
          <Column
            header="Invoice Redemer"
            headerStyle="text-align: center; width: 10rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.invoice_redeemer }}
              </div>
            </template>
          </Column>
          <Column
            header="Kode Barang"
            headerStyle="text-align: center; width: 10rem"
          >
            <template #body="slotProps">
              <div
                style="text-align: center"
                v-for="(an_item, k) in slotProps.data.items_redeemer"
                :key="k"
              >
                {{ an_item.code_redeemer }}
              </div>
            </template>
          </Column>
          <Column
            header="Nama Barang"
            headerStyle="text-align: center; width: 10rem"
          >
            <template #body="slotProps">
              <div
                style="text-align: center"
                v-for="(an_item, k) in slotProps.data.items_redeemer"
                :key="k"
              >
                {{ an_item.name_redeemer }}
              </div>
            </template>
          </Column>
          <Column
            header="Qty Redemer"
            headerStyle="text-align: center; width: 10rem"
          >
            <template #body="slotProps">
              <div
                style="text-align: center"
                v-for="(an_item, k) in slotProps.data.items_redeemer"
                :key="k"
              >
                {{ an_item.qty_redeemer | number }}
              </div>
            </template>
          </Column>
          <Column header="Harga" headerStyle="text-align: center; width: 10rem">
            <template #body="slotProps">
              <div
                style="text-align: center"
                v-for="(an_item, k) in slotProps.data.items_redeemer"
                :key="k"
              >
                {{ an_item.price_redeemer | currency }}
              </div>
            </template>
          </Column>
          <Column
            header="Total Redemer"
            headerStyle="text-align: center; width: 10rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.total_price_redeemer | currency }}
              </div>
            </template>
          </Column>
        </DataTable>
      </div>
    </div>
  </div>
</template>

<script>
var moment = require('moment')
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['user', 'isAuthenticated'])
  },
  data() {
    return {
      moment: moment,
      today: new Date().toISOString().split('T')[0],
      loading: true,
      products: null,
      expandedRows: [],
      refund: null,
      trx_date: null,
      payment_method: null,
      total_omset: 0,
      barcode: ''
    }
  },
  mounted() {
    this.getReportRefund()
    this.getAuthUser()
  },
  methods: {
    getAuthUser() {
      console.info(this.user)
      this.trx_date = this.today
    },
    getReportRefund() {
      let trx_date = this.trx_date
        ? moment(this.trx_date).format('YYYY-MM-DD')
        : this.today

      this.$http
        .get(
          `${process.env.VUE_APP_API_URL}/report/refund?date=${trx_date}&code=${this.barcode}`
        )
        .then(response => {
          if (response.status === 200) {
            this.refund = response.data.data.report_refund
            // this.payment_method = response.data.data.payment
            // this.total_omset = response.data.data.total_omset
          }
        })
    },
    closeDialog() {
      this.confirmDialog = false
    }
  }
}
</script>

<style scoped lang="scss">
/deep/ .p-progressbar {
  height: 0.5rem;
  background-color: #d8dadc;

  .p-progressbar-value {
    background-color: #607d8b;
  }
}

.qty {
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 50px;
}

.p-datatable .p-column-filter {
  display: none;
}

.table-header {
  display: flex;
  justify-content: space-between;
}

/deep/ .p-datatable.p-datatable-outlets {
  .p-datatable-header {
    padding: 1rem;
    text-align: left;
    font-size: 1.5rem;
  }

  .p-paginator {
    padding: 1rem;
  }

  .p-datatable-thead > tr > th {
    text-align: left;
  }

  .p-datatable-tbody > tr > td {
    cursor: auto;
  }

  .p-dropdown-label:not(.p-placeholder) {
    text-transform: uppercase;
  }
}

/* Responsive */
.p-datatable-outlets .p-datatable-tbody > tr > td .p-column-title {
  display: none;
}

.customer-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.status-qualified {
    background: #c8e6c9;
    color: #256029;
  }

  &.status-unqualified {
    background: #ffcdd2;
    color: #c63737;
  }

  &.status-negotiation {
    background: #feedaf;
    color: #8a5340;
  }

  &.status-new {
    background: #b3e5fc;
    color: #23547b;
  }

  &.status-renewal {
    background: #eccfff;
    color: #694382;
  }

  &.status-proposal {
    background: #ffd8b2;
    color: #805b36;
  }
}

.p-progressbar-value.ui-widget-header {
  background: #607d8b;
}

@media (max-width: 640px) {
  .p-progressbar {
    margin-top: 0.5rem;
  }
}

.product-image {
  width: 100px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}

.orders-subtable {
  padding: 1rem;
}

.product-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.status-instock {
    background: #c8e6c9;
    color: #256029;
  }

  &.status-outofstock {
    background: #ffcdd2;
    color: #c63737;
  }

  &.status-lowstock {
    background: #feedaf;
    color: #8a5340;
  }
}

.order-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.order-delivered {
    background: #c8e6c9;
    color: #256029;
  }

  &.order-cancelled {
    background: #ffcdd2;
    color: #c63737;
  }

  &.order-pending {
    background: #feedaf;
    color: #8a5340;
  }

  &.order-returned {
    background: #eccfff;
    color: #694382;
  }
}

@media screen and (max-width: 960px) {
  /deep/ .p-datatable {
    &.p-datatable-outlets {
      .p-datatable-thead > tr > th,
      .p-datatable-tfoot > tr > td {
        display: none !important;
      }

      .p-datatable-tbody > tr {
        > td {
          text-align: left;
          display: block;
          border: 0 none !important;
          width: 100% !important;
          float: left;
          clear: left;
          border: 0 none;

          .p-column-title {
            padding: 0.4rem;
            min-width: 30%;
            display: inline-block;
            margin: -0.4rem 1rem -0.4rem -0.4rem;
            font-weight: bold;
          }

          .p-progressbar {
            margin-top: 0.5rem;
          }
        }
      }
    }
  }
}

::v-deep(.p-datatable table) {
  border-collapse: collapse;
}

::v-deep(.p-datatable th),
::v-deep(.p-datatable td) {
  border: 1px solid #ccc !important;
  padding: 8px;
}
</style>
